import http from './api'

const route = 'logacesso/'

export default {
  logacesso: (username, tokencontrato, url, platform) => {
    return http.post(route + 'save', {
        username: username,
        tokencontrato: tokencontrato,
        url: url,
        platform: platform,
    })
  },
}
